import { SidebarData } from "SidebarData";
import React, { Component } from "react";
import { useLocation, NavLink } from "react-router-dom";
import { Link } from 'react-router-dom';

import { Nav } from "react-bootstrap";

import logo from "assets/img/reactlogo.png";

function Sidebar({ color, image, routes }) {
  const location = useLocation();
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  return (
    <div className="sidebar" data-image={image} data-color={color}>
      <div
        className="sidebar-background"
        style={{ 
          backgroundImage: "url(" + image + ")",
        }}
      />
      <div className="sidebar-wrapper">
        <div className="logo d-flex align-items-center justify-content-start">
          <a
            className="simple-text logo-mini mx-1"
          >
            <div className="logo-img">
              <img
                src={require("assets/img/hop.png").default}
                alt="..."
              />
            </div>
          </a>
          <a className="simple-text" >
            HOP & RIDE
          </a>
        </div>
        <Nav>

        {SidebarData.map((item, index) => {
              return (
                <li key={index} className={item.cName}>
                  <Link  className="nav-link"
                    activeClassName="active" 
                    to={item.path}>
                    <i className={item.icon} />
                    
                    <span>{item.title}</span>
                  </Link>
                </li>
              );
            })}



          {/* {routes.map((prop, key) => {
            if (!prop.redirect)
              return (
                <li
                  className={
                    prop.upgrade
                      ? "active active-pro"
                      : activeRoute(prop.layout + prop.path)
                  }
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className={prop.icon} />
                    <p>{prop.name}</p>
                  </NavLink>
                </li>
              );
            return null;
          })} */}
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
